import React from "react";
import AbsoluteWrapper from "./AbsoluteWrapper";
import { FaLinkedin, FaFacebook, FaTwitter, FaTelegram, FaReddit } from "react-icons/fa";

const contact = () => {
    //<h4 className="card-title mt-1">I'm PageFour!</h4>
  return (
    <AbsoluteWrapper>
      <section className="row justify-content-center text-center p-5">
        <article className="col-md-8">
          <div className="card p-1 m-1 shadow">
            <div className="card-body">
              
              <img src="./pictures/Contact-Us-2.jpg" width="100%"></img>


              <br></br>
              <br></br>

          <h4>CONTACT US</h4>
          <div className="wrapper-line-login"></div>

          <br></br>
          <br></br>


          <div   id = "signal-report"    className=""   style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }} >
          <a     className="logo-position" id ="Strategy" aria-expanded="false" ><img className="card-title mt-1"  width="30px" height="30px" src="./pictures/background_11.png"></img><span className="doc-content-title">Telephone</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_id" className="text-position">
                    
                    <span>US and Canada.</span>
                    <span>Product Support: 1-888-xxx-xxxx.</span>
                    <span>Business hours : 7am – 11pm ET Monday - Friday .</span>
                    <span>Business hours : 9am – 5pm  ET Saturday .</span>
                  </p>

		      </div>

          <br></br>


          <div   id = "signal-report"    className=""   style={{ backgroundImage:  'url("./pictures/background_10.jpg")' }} >
          <a    className="logo-position"  id ="Strategy" aria-expanded="false" ><img className="card-title mt-1"  width="30px" height="30px" src="./pictures/background_12.png"></img><span className="doc-content-title">Email</span></a>
          <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                   <p id="page_summary_id" className="text-position">
                   info@idms-invest.com
                  </p>

		      </div>

          <br></br>

          <div   id = "signal-report"    className=""   style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }} >
          <a     className="logo-position" id ="Strategy" aria-expanded="false" ><img className="card-title mt-1"  width="30px" height="30px" src="./pictures/background_13.jpg"></img><span className="doc-content-title">Mailing Address</span></a>
          <br></br>
                    <div className="wrapper_line"></div>
                    <br></br>
                    <p id="page_summary_id" className="text-position">
                    <span>IDMS INVESTMENT, Inc.</span>
                    <span>Calgary, AB - Canada.</span>
                    </p>


		      </div>




          <div className="contact-social-section">
                <h4>Connect With Us</h4>

                <div className="social-icons">

                    <a
                        href="https://linkedin.com/in/YOUR_PROFILE"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaLinkedin />
                    </a>

                    <a
                        href="https://facebook.com/YOUR_PAGE"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaFacebook />
                    </a>

                    <a
                        href="https://twitter.com/YOUR_HANDLE"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaTwitter />
                    </a>

                    <a
                        href="https://t.me/YOUR_TELEGRAM"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaTelegram />
                    </a>


                     <a href="https://www.reddit.com/r/YOUR_COMMUNITY" target="_blank" rel="noopener noreferrer">
                        <FaReddit />
                    </a>

                </div>
            </div>




            </div>
          </div>
        </article>
      </section>
    </AbsoluteWrapper>
  );
};

export default contact;
